import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes("Support for defaultProps will be removed from function components") ||
      args[0].includes("uses the legacy childContextTypes API") ||
      args[0].includes("uses the legacy contextTypes API") ||
      args[0].includes("findDOMNode is deprecated"))
  ) {
    return; // Abaikan warning dari library reactstrap (React 18 deprecation)
  }
  originalError(...args);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
